/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedbackHighlightingAnyOf } from './taskFeedbackHighlightingAnyOf';

/**
 * Optional highlighting of text segments by dimension
 */
export type TaskFeedbackHighlighting = TaskFeedbackHighlightingAnyOf | null;
